import _ from 'lodash';
import {
  TOGGLE_REDUX_PATH,
  TOGGLE_ERROR,
  TOGGLE_LOADING,
  TOGGLE_SUCCESS,
} from 'app-ui-componentlibrary/dist/common/constants';
import {ENDPOINT_TOGGLE_MAPPINGS} from 'common/endpoints';
import {BREAKPOINTS, debugBreakpoint} from './debug';

export const getTogglesStatus = (state) => {
  const togglesLoading = _.get(state, `${TOGGLE_REDUX_PATH}.loading`, true);
  const togglesError = _.get(state, `${TOGGLE_REDUX_PATH}.error`, false);
  const result = togglesError
    ? TOGGLE_ERROR
    : togglesLoading
    ? TOGGLE_LOADING
    : TOGGLE_SUCCESS;
  return result;
};

export const getToggles = (state) => {
  return _.get(state, `${TOGGLE_REDUX_PATH}.toggles`);
};

export const unpartitionedToggleIsOn = (state, toggleName) => {
  const toggles = getToggles(state);
  return _.includes(toggles, toggleName);
};

export const getMatchFromToggleMap = (pathToCheck) => {
  const endpoints = _.keys(ENDPOINT_TOGGLE_MAPPINGS);
  const matchingKey = _.find(endpoints, (endpoint) => {
    return _.startsWith(pathToCheck, endpoint);
  }); // assumes the path will always be a superset of the endpoint map keys
  return _.get(ENDPOINT_TOGGLE_MAPPINGS, matchingKey, {});
};

// TODO remove OpenAPI toggle code
export const getToggledEndpoint = (state, endpoint) => {
  // if it's in the mapping and the toggle is enabled, make V2, else leave as is
  const {mostRecentVersion, toggle} = getMatchFromToggleMap(endpoint);
  const openApiCutoverToggleCheck = unpartitionedToggleIsOn(state, toggle);
  return openApiCutoverToggleCheck
    ? _.replace(endpoint, '/v1/', `/v${mostRecentVersion}/`)
    : endpoint;
};

export const getInfo = (state, endpoint) => ({
  baseUrl: getToggledEndpoint(state, endpoint),
  isV2: unpartitionedToggleIsOn(state, _.get(getMatchFromToggleMap(endpoint), 'toggle')),
});

// END TODO

const EVERYONE_COLLAB_TOGGLE = 'enableCollaboration';
const COLLAB_TOGGLE_POSTERN = 'dynamicComponent.collaboration.enableCollaboration';
const CONFIG_ENABLED_TOGGLE = 'config.collaboration';
export const COLLAB_GRANT_IDS = [];

export const alwaysRoomManaged = (state, args) => {
  const postern = _.get(state, COLLAB_TOGGLE_POSTERN);
  if (postern !== undefined) {
    if (postern === true || postern === false) {
      return postern;
    } else {
      if (_.get(postern, args.storePath) !== undefined) {
        return _.get(postern, args.storePath);
      }
    }
  }
  if (unpartitionedToggleIsOn(state, EVERYONE_COLLAB_TOGGLE)) {
    return true;
  }
  const grantId = _.get(
    args,
    'initState.data.grantId',
    _.get(state, 'dynamicComponent.data.grantId')
  );
  if (_.includes(COLLAB_GRANT_IDS, grantId)) {
    return true;
  }
  const toggleDirection =
    _.get(state, `dynamicComponent.${CONFIG_ENABLED_TOGGLE}`) ||
    _.get(args, `initState.${CONFIG_ENABLED_TOGGLE}`);
  if (toggleDirection) {
    if (Array.isArray(toggleDirection)) {
      // if it's an array assume it's full of org ids
      const orgId = _.get(
        args,
        'initState.data.organizationId',
        _.get(state, 'dynamicComponent.data.organizationId')
      );
      return _.includes(
        _.map(toggleDirection, (id) => `${id}`),
        `${orgId}`
      );
    } else {
      return true;
    }
  }
  // default off
  return false;
};
// add your dependency here if you want it managed by CE server
const roomManagedDynamicComponentPaths = {
  ['data']: alwaysRoomManaged,
  ['context.application']: alwaysRoomManaged,
  ['context.subApplication']: alwaysRoomManaged,
  ['context.grant']: alwaysRoomManaged,
  ['context.subGrant']: alwaysRoomManaged,
  ['context.closeout']: alwaysRoomManaged,
  ['context.awardRecommendation']: alwaysRoomManaged,
  ['context.subAwardRecommendation']: alwaysRoomManaged,
  ['context.financialReport']: alwaysRoomManaged,
  ['context.payment']: alwaysRoomManaged,
  ['context.closeoutReport']: alwaysRoomManaged,
  ['context.rfi']: alwaysRoomManaged,
  ['context.bsirReport']: alwaysRoomManaged,
};

export const getRequestStorePath = (request) => {
  // sync with logic in saveFromReduxStateToService
  return request.collaborationStorePath
    ? request.collaborationStorePath
    : request.entityTypeReduxPath
    ? request.entityTypeReduxPath
    : request.objectType
    ? `context.${request.objectType}`
    : request.entityType !== 'data'
    ? `context.${request.entityType}`
    : 'data';
};

export const isRoomManagedPath = (state, request) => {
  let storePath = getRequestStorePath(request);
  debugBreakpoint(BREAKPOINTS.collaborationInit);
  const deciderFn = roomManagedDynamicComponentPaths[storePath];
  const result = deciderFn && deciderFn(state, request);
  debugBreakpoint(
    BREAKPOINTS.collaborationInit ||
      BREAKPOINTS.collaborationLocalSync ||
      BREAKPOINTS.collaborationRemoteSync
  );
  return result;
};
